import React, { Fragment } from 'react';
import { Container } from '@mui/material';
//
import TransactionHistoryTable from './TransactionHistoryTable';
import { useGetWLIDDropdownQuery } from '../../../store/api/wl.api';
import { useGetPublishersDropdownQuery } from '../../../store/api/publisher.api';
import { useGetEndpointsDropdownQuery } from '../../../store/api/endpoint.api';

const TopUpRequests = () => {
  // hooks
  const { data: wlidOptions = [] } = useGetWLIDDropdownQuery();
  const { data: ugwPublisherOptions = [] } = useGetPublishersDropdownQuery();
  const { data: ugwEndpointOptions = [] } = useGetEndpointsDropdownQuery();

  return (
    <Fragment>
      <Container maxWidth='100%'>
        <TransactionHistoryTable
          clientOptionsData={wlidOptions}
          publisherOptionsData={ugwPublisherOptions}
          endpointOptionsData={ugwEndpointOptions}
        />
      </Container>
    </Fragment>
  );
};
export default TopUpRequests;
